import React from 'react';
import PropTypes from 'prop-types';

import SummaryTableHead from './SummaryTableHead';
import SummaryTableBody from './SummaryTableBody';

class SummaryTableComponent extends React.PureComponent {
  static propTypes = {
    levelsProps: PropTypes.array.isRequired,
    categoricalParameter: PropTypes.string.isRequired,
    numericalParameter: PropTypes.string.isRequired
  }

  render () {
    return (
      <div className="content-item">
        <div className="flex flex-shrink space-between">
          <p className="font-700 mb-5">
            Summary Table
          </p>
        </div>

        <table id="summary-table" className="main-table">
          <colgroup>
            <col className="bg-grey-150" />
          </colgroup>

          <SummaryTableHead
            categoricalParameter={this.props.categoricalParameter}
          />

          <SummaryTableBody {...this.props} />
        </table>
      </div>
    );
  }
}

export default SummaryTableComponent;
